<template>
  <select
    @change="handleChange"
    class="rounded border-gray-200 border p-2 pr-10 hover:border-gray-300 focus:outline-none"
    :value="value"
  >
    <option v-for="option in options" :key="option" :value="option">
      <!--
        only 2 cases are possible while displaying current selected option: prepend and append
        So using slots is a better idea
       -->
      <slot name="prepend"></slot>
      {{ option }}
      <slot name="append"></slot>
    </option>
  </select>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {}
  },
  methods: {
    handleChange (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>
